import Box from './Box'
import Dot from './Dot'
import Provider from './Provider'
import View from './View'

// setPragma(createElement);

export default {
  Box,
  Dot,
  Provider,
  View,
}
